import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { WebsocketMessage } from './websocketMessage';
import { BehaviorSubject, Subject } from 'rxjs';
import { AuthService } from '~app/auth/auth.service';

declare const window: any;

export type WsConnectionStatus = 'init' | 'connected' | 'closed' | 'reconnecting' | 'reconnected';

/**
 * Small listener service for Primus websocket.
 */
@Injectable()
export class WebsocketService {
  private worker: Worker;
  private jwt: string;

  /**
   * Websocket message stream
   * @type {Subject<any>}
   */
  private websocketMessage = new Subject<WebsocketMessage>();
  /**
   * Observable for new websocket messages
   * @type {Observable<any>}
   */
  public newWebsocketMessage$ = this.websocketMessage.asObservable();

  /**
   * Websocket connection status
   * @type {BehaviourSubject<WsConnectionStatus>}
   */
  private wsConnectionStatus = new BehaviorSubject<WsConnectionStatus>('init');

  /**
   * Observable for websocket connection status
   * @param {Observable<WsConnectionStatus>}
   */
  public wsConnectionStatus$ = this.wsConnectionStatus.asObservable();

  /**
   * Initialize Primus
   */
  constructor(authService: AuthService) {
    authService.login$.subscribe(login => {
      this.jwt = login.token;
      if (this.worker) {
        console.log('Update websocket client token');
        this.worker.postMessage({command: 'UPDATE_TOKEN', token: login.token});
      } else {
        console.log('Initialize websocket worker');
        this.worker = new Worker(new URL('./websocket.worker', import.meta.url), {
          type: 'module',
          name: 'websocket',
        });
        this.worker.postMessage({command: 'INIT', url: environment.websocketURL, token: login.token});
        this.worker.onmessage = (msg) => this.handleWorkerMessage(msg);
      }
    });
    console.log('Websocket service constructed');
  }

  public sendPrimusMessage(message: any) {
    this.worker.postMessage({command: 'SEND_MESSAGE', message, url: environment.websocketURL, token: this.jwt});
  }

  private handleWorkerMessage (event: any) {
    switch (event.data.type) {
      case 'DATA':
        this.websocketMessage.next(event.data.data);
        break;
      case 'STATUS':
        this.wsConnectionStatus.next(event.data.data);
        break;
      default:
        console.error('Unknow message from websocket worker: ', event.data);
        break;
    }
  }
}
